/* TASK-2023 (owner report) — :active press animation on the collection
   grid's Add-to-cart button wasn't firing on touch devices (worked fine
   on the PDP sticky button, which sits in a position:fixed bar outside
   any scrollable list). Root cause: iOS Safari (and several Android
   WebViews) only apply :active styles to elements inside a scrollable
   container if there's at least one touchstart listener registered
   somewhere in the document — without one, the browser treats every
   tap as a potential scroll gesture and skips :active entirely to save
   a reflow. This is the classic "empty touchstart" fix: registering a
   no-op passive touchstart listener on document is enough to opt every
   element on the page into normal :active behaviour, matching desktop.
   No other code path is touched — this only changes whether iOS/Android
   honour the existing CSS :active rules already on .ils-card-btn-add
   and .ils-weight-btn. */
(function () {
  'use strict';
  document.addEventListener('touchstart', function () {}, { passive: true });
})();
